/**
 * Small badge component used everywhere AI-generated content is shown.
 * Surfaces transparency requirement: "Generated by FWM Copilot.
 * Requires approval before publication."
 */
import { Sparkles } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

export const CopilotBadge = ({ status, className = '' }) => {
  const map = {
    review_required: { c: 'bg-amber-50 text-amber-700 border-amber-200',
      label: 'Generated by FWM Copilot — Requires approval' },
    teacher_approved: { c: 'bg-violet-50 text-violet-700 border-violet-200',
      label: 'Teacher approved — Ready to publish' },
    published: { c: 'bg-emerald-50 text-emerald-700 border-emerald-200',
      label: 'AI-assisted · Published' },
    rejected: { c: 'bg-slate-100 text-slate-500 border-slate-200',
      label: 'AI proposal · Rejected' },
  };
  const meta = map[status] || map.review_required;
  return (
    <Badge variant="outline"
      className={`inline-flex items-center gap-1 text-[10px] font-medium ${meta.c} ${className}`}
      data-testid={`copilot-badge-${status || 'unknown'}`}>
      <Sparkles className="h-3 w-3" />
      {meta.label}
    </Badge>
  );
};

export default CopilotBadge;
